import type { SxProps, Theme } from '@mui/material';

export const root: SxProps<Theme> = {};

export const summary: SxProps<Theme> = {};

export const details: SxProps<Theme> = {
  px: 1.5,
  pt: 1,
  pb: 1.5,
  color: 'grey.700',
};
